import { FormField, SearchField } from '@/components/custom/erp';
import { QUERY_KEYS, supplierSearchColumns } from '@/constants';
import { UseSearchFieldStatesReturn } from '../../hooks';
import { Label } from '@/components/ui/label';
import { NhaCungCap } from '@/types/schemas';

interface DetailsTabProps {
  searchFieldStates: UseSearchFieldStatesReturn;
}

const DetailsTab: React.FC<DetailsTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='w-[800px] min-w-[800px] space-y-2 p-4'>
      <div className='flex flex-col space-y-1'>
        <div className='flex items-center'>
          <div className='flex-1'>
            <div className='flex items-center'>
              <Label className='w-40'>Mã nhà cung cấp:</Label>
              <SearchField<NhaCungCap>
                type='text'
                columnDisplay='customer_code'
                displayRelatedField='customer_name'
                searchEndpoint={`/${QUERY_KEYS.NHA_CUNG_CAP}`}
                searchColumns={supplierSearchColumns}
                value={searchFieldStates.supplier?.customer_code || ''}
                relatedFieldValue={searchFieldStates.supplier?.customer_name || ''}
                onRowSelection={searchFieldStates.setSupplier}
              />
            </div>
            <div className='flex gap-1'>
              <FormField
                name='mau_bc'
                label='Mẫu báo cáo'
                labelClassName='w-40'
                type='select'
                options={[
                  { value: 20, label: 'Mẫu tiền chuẩn' },
                  { value: 30, label: 'Mẫu ngoại tệ' }
                ]}
                className='w-[400px]'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
